import PathScheduleRuntime from './PathScheduleRuntime';

export default class PathSchedule {
    public enabled: boolean = false;
    public runTimes: PathScheduleRuntime[] = [];
}
